import {getPreliminaryInvoice} from '../../../../../selectors/placed-order'
import {isInAccessibilityMode} from '../../../../../selectors/seating/mode'
import {getPlacesInBasketCount} from '../../../../../selectors/seating/places'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {Footer as Presentation} from './footer'
import {FooterOwnProps, FooterRuntimeProps} from './interfaces'

const mapRuntime = ({state, actions: {setShowAccessibilityMode}}: DetailsPageAppProps): FooterRuntimeProps => ({
  placesInBasketCount: getPlacesInBasketCount(state),
  invoice: getPreliminaryInvoice(state),
  showAccessibilityMode: isInAccessibilityMode(state),
  setShowAccessibilityMode,
})

export const Footer = connect<FooterOwnProps, FooterRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
